"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Controls = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const muted_on_entering_call_modal_1 = __importDefault(require("./muted_on_entering_call_modal"));
const muted_on_call_message_1 = __importDefault(require("./muted_on_call_message"));
const end_call_button_1 = require("../in_call/tool_bar/tools/end_call_button");
const logger_1 = require("../../util/logger");
function Controls({ audioState, videoState, inCall, onEndCallButtonClicked }) {
    const { enabled: audioEnabled, toggleEnabled: toggleAudioEnabled, notAvailable: audioNotAvailable, showMicTroubleshootingMessage, } = audioState;
    const { enabled: videoEnabled, toggleEnabled: toggleVideoEnabled, notAvailable: videoNotAvailable, showCameraTroubleshootingMessage, } = videoState;
    const microphoneMuteStatus = audioEnabled ? 'Mute' : 'Muted';
    const [showMuteModalOnEntry, setShowMuteModalOnEntry] = (0, react_1.useState)(true);
    const [showMuteModalOnCall, setShowMuteModalOnCall] = (0, react_1.useState)(false);
    const theme = (0, ui_react_1.useTheme)();
    (0, react_1.useEffect)(() => {
        setShowMuteModalOnEntry(!!(microphoneMuteStatus === 'Muted' && inCall && showMuteModalOnEntry));
    }, [microphoneMuteStatus, inCall, showMuteModalOnEntry]);
    const handleUnmuteClick = (0, react_1.useCallback)(() => {
        toggleAudioEnabled();
        setShowMuteModalOnEntry(false);
    }, [toggleAudioEnabled]);
    const handleAudioMuteButtonClicked = () => {
        if (audioNotAvailable) {
            if (showMicTroubleshootingMessage) {
                showMicTroubleshootingMessage();
            }
            else {
                logger_1.logger.warn('Audio is unavailable and showMicTroubleshootingMessage is not defined');
                return;
            }
        }
        else {
            toggleAudioEnabled();
            setShowMuteModalOnCall(!!(audioEnabled && inCall && !showMuteModalOnEntry));
        }
    };
    const handleCameraMuteButtonClicked = () => {
        if (videoNotAvailable) {
            if (showCameraTroubleshootingMessage) {
                showCameraTroubleshootingMessage();
            }
            else {
                logger_1.logger.warn('Video is unavailable and showCameraTroubleshootingMessage is not defined');
                return;
            }
        }
        else {
            toggleVideoEnabled();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showMuteModalOnCall && (0, jsx_runtime_1.jsx)(muted_on_call_message_1.default, {}), (0, jsx_runtime_1.jsxs)(ControlsContainer, Object.assign({ inCall: inCall }, { children: [(0, jsx_runtime_1.jsxs)(ui_react_1.Column, Object.assign({ alignItems: "center", flexBasis: !inCall ? '50%' : undefined }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { position: 'relative' } }, { children: [audioNotAvailable && (0, jsx_runtime_1.jsx)(MediaNotAvailableIndicator, {}), (0, jsx_runtime_1.jsx)(SwitchButton, { active: {
                                            icon: 'MuteIcon',
                                        }, inactive: {
                                            icon: 'MutedIcon',
                                        }, slashColor: theme.colors.red50, testId: audioNotAvailable
                                            ? 'mic-toggle-btn-not-available'
                                            : `mic-toggle-btn-${audioEnabled ? 'on' : 'off'}`, label: 'Microphone', state: audioNotAvailable ? true : audioEnabled, handleClick: handleAudioMuteButtonClicked, inCall: inCall })] })), !inCall && ((0, jsx_runtime_1.jsx)(ui_react_1.Box, Object.assign({ marginTop: 3, textAlign: "center" }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "medium" }, { children: audioNotAvailable ? 'Unavailable' : microphoneMuteStatus })) })))] })), inCall && (0, jsx_runtime_1.jsx)(end_call_button_1.EndCallButton, { onClicked: onEndCallButtonClicked, host: true }), (0, jsx_runtime_1.jsxs)(ui_react_1.Column, Object.assign({ alignItems: "center", flexBasis: !inCall ? '50%' : undefined }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { position: 'relative' } }, { children: [videoNotAvailable && (0, jsx_runtime_1.jsx)(MediaNotAvailableIndicator, {}), (0, jsx_runtime_1.jsx)(SwitchButton, { active: {
                                            icon: 'CameraIcon',
                                        }, inactive: {
                                            icon: 'CameraOffIcon',
                                        }, slashColor: theme.colors.red50, testId: `camera-toggle-btn-${videoEnabled ? 'on' : 'off'}`, label: 'Camera', state: videoNotAvailable ? true : videoEnabled, handleClick: handleCameraMuteButtonClicked, inCall: inCall })] })), !inCall && ((0, jsx_runtime_1.jsx)(ui_react_1.Box, Object.assign({ marginTop: 3 }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "medium" }, { children: videoNotAvailable ? 'Unavailable' : 'Camera' })) })))] })), !audioNotAvailable && showMuteModalOnEntry && ((0, jsx_runtime_1.jsx)(muted_on_entering_call_modal_1.default, { handleUnmuteClick: handleUnmuteClick, handleCloseModal: () => setShowMuteModalOnEntry(false) }))] }))] }));
}
exports.Controls = Controls;
const ControlsContainer = ({ children, inCall }) => {
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ margin: "16px auto 0px", justifyContent: "space-evenly", mt: inCall ? '' : 4, mb: inCall ? 4 : '', flexGrow: 1, zIndex: 3, maxWidth: "500px" }, { children: children })));
};
function SwitchButton({ state, inCall, testId, fillLevel, slashColor, handleClick, label, active, inactive, }) {
    const theme = (0, ui_react_1.useTheme)();
    const activeInCall = inCall && state;
    return ((0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { size: 'CVLarge', "data-testid": testId, background: activeInCall ? 'whiteA20' : 'grey10', fill: activeInCall
            ? theme.colors.white
            : !activeInCall
                ? theme.colors.grey50
                : theme.colors.red50, slashcolor: slashColor, fillLevel: fillLevel, onClick: handleClick, iconName: state ? active.icon : inactive.icon, label: label, iconSize: "30px" }));
}
const MediaNotAvailableIndicator = ui_react_1.styled.div `
    position: absolute;
    background: ${props => props.theme.colors.white};
    box-shadow: ${props => props.theme.shadow.small};
    bottom: 0;
    height: 22px;
    width: 22px;
    right: 0;
    border-radius: 11px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:before {
        position: absolute;
        content: '';
        width: 100%;
        height: 4px;
        background-color: ${props => props.theme.colors.red50};
        text-align: center;
        transform: scale(0.5, 0.5) rotate(45deg);
    }
    &:after {
        position: absolute;
        content: '';
        width: 100%;
        height: 4px;
        background-color: ${props => props.theme.colors.red50};
        text-align: center;
        transform: scale(0.5, 0.5) rotate(-45deg);
    }
`;
//# sourceMappingURL=controls.js.map